import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { ProgressService } from './progress.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { ProgressListComponent } from './list/list.component';

import { ProgressFormComponent } from './detail/detail.component';
import { TooltipModule } from 'ngx-bootstrap';
import { ProgressGuard } from './progress.guard';
import { ProgressListGuard } from './progress-list.guard';
import { PartyListGuard } from './party-list.guard';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    ProgressListComponent,
    ProgressFormComponent
    // KeysPipe,
  ],
  exports: [
    // ProgressFormComponent
  ]
})
export class ProgressModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ProgressModule,
      providers: [
        ProgressService,
        ProgressGuard,
        ProgressListGuard,
        PartyListGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/progress/progress.module.ts